export default "__VITE_ASSET__W0yn1vm6__"